import { EnduserFormWizardBody } from "./EnduserFormWizardBody";
import { usePinnedFormDialogShallowStore } from "../store";
import type { SurfaceWizardProps } from "./types";

/** The wizard as rendered by the portal's pinned-form dialog, bound to that surface's store. */
export const PinnedFormDialogWizard = (props: SurfaceWizardProps) => (
  <EnduserFormWizardBody {...props} useFormShallowStore={usePinnedFormDialogShallowStore} />
);
